import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Twitter = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M5.773 13.08c4.53 0 7.008-3.91 7.008-7.299 0-.11 0-.221-.007-.331a5.131 5.131 0 0 0 1.229-1.328c-.45.207-.927.343-1.415.403.514-.32.9-.824 1.083-1.418a4.82 4.82 0 0 1-1.564.622 2.395 2.395 0 0 0-2.96-.504c-.982.547-1.49 1.713-1.238 2.844-1.98-.104-3.826-1.078-5.076-2.68-.654 1.172-.32 2.671.762 3.424a2.371 2.371 0 0 1-1.118-.321v.032c0 1.221.827 2.273 1.976 2.515a2.365 2.365 0 0 1-1.112.044c.323 1.045 1.248 1.76 2.301 1.781a4.819 4.819 0 0 1-3.645 1.063 6.773 6.773 0 0 0 3.776 1.15"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Twitter;
